/**
 * Api documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MIMModelDecompositionChartRequestDTO { 
    /**
     * Measured client identifier
     */
    clientId: number;
    /**
     * Brand identifier within the client
     */
    brandId: number;
    /**
     * Conversion event type for the decomposition chart
     */
    conversionType: string;
    /**
     * Chart period start date in ISO-8601 format
     */
    dateStart: string;
    /**
     * Chart period end date in ISO-8601 format
     */
    dateStop: string;
    /**
     * Time resolution for chart data points
     */
    resolution: MIMModelDecompositionChartRequestDTO.ResolutionEnum;
    /**
     * Decomposition view: \'DecompositionTotalConv\' for absolute values, \'DecompositionTotalConvPerc\' for percentage breakdown
     */
    chartViewBy: MIMModelDecompositionChartRequestDTO.ChartViewByEnum;
}
export namespace MIMModelDecompositionChartRequestDTO {
    export type ResolutionEnum = 'year' | 'month' | 'week' | 'day';
    export const ResolutionEnum = {
        Year: 'year' as ResolutionEnum,
        Month: 'month' as ResolutionEnum,
        Week: 'week' as ResolutionEnum,
        Day: 'day' as ResolutionEnum
    };
    export type ChartViewByEnum = 'DecompositionTotalConv' | 'DecompositionTotalConvPerc';
    export const ChartViewByEnum = {
        DecompositionTotalConv: 'DecompositionTotalConv' as ChartViewByEnum,
        DecompositionTotalConvPerc: 'DecompositionTotalConvPerc' as ChartViewByEnum
    };
}


